// Whether the UI may offer to assign a client's account owner. FALSE until a write
// RPC exists and is confirmed with the backend: a button with nothing behind it
// reads as broken, so it is not rendered at all. This is the single seam to flip —
// the components and the api wrapper (assignClientOwner) are already built and
// tested against a mocked RPC.

/**
 * @returns {boolean}
 */
export const canAssignAccountOwner = () => false;

// Whether the Clients list may ask for a suggested owner per unassigned row. FALSE until
// a batched read (`fn_suggest_account_owners`) exists and is confirmed with the backend:
// the single-client RPC would cost one call per row, per page view. With this off the
// list makes no suggestion call at all and rows read exactly as they do today.

/**
 * @returns {boolean}
 */
export const canSuggestOwnersInList = () => false;
